import React from 'react';
import { KiteIcon } from '@kite/react-kite';
import './AccessServiceIcon.scss';

export interface IAccessServiceIconProps {}

const iconMap = {
  audio_description_and_full_audio: 'ki-audio-description',
  audio_description: 'ki-audio-description',
  closed_captions: 'ki-cc',
};

const ariaLabelMap = {
  audio_description_and_full_audio: 'Audio Description + Full Audio',
  audio_description: 'Audio Description only',
  closed_captions: 'Closed Captioning',
};

const AccessServiceIcon = ({ serviceType }) => {
  return (
    <KiteIcon
      className="access-service-icon"
      icon={iconMap[serviceType]}
      ariaLabel={ariaLabelMap[serviceType]}
      size="1.5rem"
    />
  );
};

export default AccessServiceIcon;
